import React, { useState, useContext, useEffect } from 'react';
import { useCallback } from 'react';
import { jwtDecode } from "jwt-decode";
import { api } from './config';
const AppContext = React.createContext();


const AppProvider = ({ children }) => {
  
  
  const [searchTerm, setSearchTerm] = useState("");
  const [searchText, setSearchText] = useState('');
  const [searchTextShow, setSearchTextShow] = useState('');
  // const [searchType, setSearchType] = useState("book");
  // const [searchCategory, setSearchCategory] = useState(""); // Default to search
  const [searchCriteria, setSearchCriteria] = useState({
    type: "book", // default search type
    category: 0, // default search category
    categoryname: "" ,
    allFilter:"",
    location: "",
    isSearching: false,
  });
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [resultTitle, setResultTitle] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const fetchData = async (currentType, retryCount = 0, maxRetries = 3) => {
    const response = await fetch(`${api}/book_author/books`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        title: searchTerm || "",
        type: currentType,
        category: searchCriteria.category || "",
      }),
    });
  
    const data = await response.json();
  
    if (data.length === 0 && retryCount < maxRetries) {
      // Define the order of types to try next
      const typesOrder = [ "journal", "article", "author"];
      const nextTypeIndex = typesOrder.indexOf(currentType) + 1;
  
      if (nextTypeIndex < typesOrder.length) {
        // Try fetching with the next type
        await fetchData(typesOrder[nextTypeIndex], retryCount + 1, maxRetries);
      }
    } else {
     
      setBooks(data);
     // console.log("Data received:", searchCriteria);
      setSearchCriteria(prevCriteria => ({
        ...prevCriteria,
        allFilter: currentType,
        type: currentType,
        found: true,
        location: "main",
      }))
    }
  };
  
  // Call fetchData with the initial type and max retries
 // fetchData("journal", 0, 3);

 const fetchBooks = useCallback(async () => {

    setLoading(true);
    //if all search criteria are empty, return dont fetch
    // if ((!searchTerm && !searchCriteria.type && !searchCriteria.category) || searchCriteria.found) {
    //   setLoading(false);
    //         return;
    //     }
      try {
      
      const response = await fetch(`${api}/book_author/books`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          title: searchTerm || "",
          type: searchCriteria.type || "",
          category: searchCriteria.category || "",
          isSearching: searchCriteria.isSearching || false,
        }),
      });
      const data = await response.json();
     
      if(searchCriteria.isSearching &&!searchCriteria.found&& data && data.length === 0){
        fetchData("journal",0,3);
      }
      if (data && data.length > 0) {
        setBooks(data);
        setResultTitle(searchTerm.length > 0 ? "النتيجة " : "النتيجة");
      } else {
        setBooks([]);
        setResultTitle(searchTerm.length > 0 ? "لايوجد نتيجة" : "لايوجد نتيجة");
      }
    } catch (error) {
      console.error("Failed to fetch books:", error);
    } finally {
      setLoading(false);
    }
  }, [searchTerm, searchCriteria.type, searchCriteria.category]); // Added searchCriteria.type and searchCriteria.category as dependencies

  const checkTokenExpiration = () => {
    const token = localStorage.getItem('token');
    
    if (token) {
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000; // Convert milliseconds to seconds
      
      if (decodedToken.exp < currentTime) {
        // Token has expired, clear it from local storage
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('username');
      }
    }else{
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('username');
    }
    const username = localStorage.getItem('username');
    setIsLoggedIn(!!username); // Check if username exists in localStorage
    
  };

  useEffect(() => {
    checkTokenExpiration();
  }, [checkTokenExpiration]);

  useEffect(() => {
    fetchBooks();
  }, [fetchBooks]); // You only need to list fetchBooks here because its definition includes searchTerm and searchCriteria

  return (
    <AppContext.Provider value={{
      loading, books, setSearchTerm, resultTitle, setResultTitle, searchCriteria, setSearchCriteria,searchText, setSearchText,searchTextShow, setSearchTextShow
    }}>
      {children}
    </AppContext.Provider>
  );
}

export const useGlobalContext = () => {
  return useContext(AppContext);
}

export { AppContext, AppProvider };